import { render, staticRenderFns } from "./allot.vue?vue&type=template&id=4c192c24"
import script from "./allot.vue?vue&type=script&lang=ts"
export * from "./allot.vue?vue&type=script&lang=ts"
import style0 from "./allot.vue?vue&type=style&index=0&id=4c192c24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports